import React from 'react';

const FoodIntakeRow = (props) => {
  const {columns, columnIndex, meal} = props;

  return (
    <tr>
      <td>
        {meal} {columnIndex + 1}
      </td>
      {columns.map((column, index) => (
        <td></td>
      ))}
    </tr>
  );
}

export default FoodIntakeRow;
